import React, { useEffect, useState, useRef, useCallback } from 'react';
import { FormControlLabel, FormControl, RadioGroup, Radio, TextField } from "@material-ui/core";
import RadioButtonUncheckedIcon from '@material-ui/icons/RadioButtonUnchecked';
import Autocomplete from '@material-ui/lab/Autocomplete';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import config from '../../config/config';
import { makeStyles } from '@material-ui/core/styles';
import NumberFormat from 'react-number-format';
import CloseIcon from '@material-ui/icons/Close';
import '../../../styles/loanofficer-realestateagent.scss';

export default function RealEstatAgent(props) {
	const ref = useRef()
	const [realEstateAgent, setRealEstateAgent] = useState([])
	const [isLoading, setIsLoading] = useState(false);
	const [isOpen, setIsOpen] = useState(false);
	const [isExists,setIsExists] = useState(true);
	const [realEstateAgentValue, setRealEstateAgentValue] = useState(null)

	const myDefaultOption = { calque_partner_contact_full_name: "+Add New", partner_contact_role: 2, calque_partner_contact_id: 0 };

	const handleEmail = (e) => {
		props.values.real_estate_agent_info.email = e.target.value.replace(/\s/g, "");
	}
	const handleFirstName = (e) => {
		props.values.real_estate_agent_info.first_name = e.target.value
	}
	const handleLastName = (e) => {
		props.values.real_estate_agent_info.last_name = e.target.value
	}
	const phoneNumberFormat = (event) => {
		let brackets = event.target.value.replace(/[-()+]/g, '');
		let spaces = brackets.split(" ").join("");
		props.values.real_estate_agent_info.phone_number = spaces
	}
	const resetInputField = () => {
		props.values.real_estate_agent = null;
		props.values.real_estate_agent_info.first_name = '';
		props.values.real_estate_agent_info.last_name = '';
		props.values.real_estate_agent_info.email = ''
		props.values.real_estate_agent_info.phone_number = ''
	};
	
	const resetAllInputField = () => {
		props.values.real_estate_agent = null;
		props.values.real_estate_agent_info.first_name = '';
		props.values.real_estate_agent_info.last_name = '';
		props.values.real_estate_agent_info.email = ''
		props.values.real_estate_agent_info.phone_number = ''
		props.setSelectedAgent(null);
		props.setIsSelectedAgent(false);
		props.setAgentSelected(null);
		props.setIsDisabledAgent(false);
        setIsExists(true);
	};
	
	const handleSearchValue = (event) => {
		setRealEstateAgentValue(event.target.value)
		if (event.target.value.length > 0) {
			let partner_contact = props.partnerContactRole && props.partnerContactRole.find((res) =>{
				if(res.partner_contact_role_name == "Real Estate Agent") {
					return res.partner_contact_role_id;
				}
			})
			if(event.target.value !== '+Add New ') {
				setRealEstateAgentValue(event.target.value)
			}
			setIsLoading(true)
			fetch(`${props?.partner?.partner_id != null ? `${config.baseUrlCP}search-partner-contact?partner_id=${props?.partner?.partner_id}&partner_contact_role_id=${partner_contact?.partner_contact_role_id ? partner_contact?.partner_contact_role_id : null}&q=${event.target.value}` : `${config.baseUrlCP}get-calque-partner-contact?`}`,
				{
					headers: {
						"Authorization": `${process.env.REACT_APP_API_KEY}`,
'Accept-Encoding': 'gzip, deflate',
					}
				})
				.then(async response => {
					const result = await response.json();
                    let agentValue = [myDefaultOption];
                    
                    if (response.status === 201 || response.status === 200) {
                        if (result.length > 0) {
                            const filteredAgents = result.filter((item) => item.partner_contact_role === 2);
                            agentValue = [myDefaultOption, ...filteredAgents];
                        }
                    }
                    setRealEstateAgent(agentValue);
                    setIsOpen(true);
                })
                .catch((error) => {
                    console.error(error);
                })
                .finally(() => {
                    setIsLoading(false);
                });
        } else {
            setRealEstateAgent([myDefaultOption]);
            setIsOpen(false);
            setIsLoading(false);
        }
	}
	const handleNotFound = () => {
		props.values.real_estate_agent = '+Add New';
		props.formik.setFieldValue('real_estate_agent', '+Add New')
		setRealEstateAgentValue('+Add New');
		setIsOpen(false)
	}
	const handleCloseIcon = () => {
		setRealEstateAgentValue(null)
		props.values.real_estate_agent = null;
		setRealEstateAgent([])
		setIsOpen(false)
		props.setIsDisabledAgent(false)
	}
	const debounce = (func) => {
		let timeoutId;
		return function (...args) {
			const context = this;
			if (debouncedSearch) clearTimeout(timeoutId);
			setRealEstateAgent([])
			setIsLoading(true)
			timeoutId = setTimeout(() => {
				timeoutId = null
				func.apply(context, args);
			}, 1000);
		}
	};
	const handleChangeValue = (newValue) => {
		props.setSelectedAgent(newValue);
		if (newValue === '+Add New'){
			props.setIsSelectedAgent(true);
			setRealEstateAgentValue('');
            resetInputField()
			setIsExists(false);
		}else if(newValue === null){
            props.setAgentSelected(null);
			if(props.agentSelected !== null){
			props.formik.setFieldValue('real_estate_agent_info.first_name', "")
            props.formik.setFieldValue('real_estate_agent_info.last_name', "")
			}
        }
        else{
			setIsExists(true);
			props.setIsSelectedAgent(false);
			realEstateAgent && realEstateAgent.map(lo => {
				if (lo.calque_partner_contact_full_name === newValue) {
					props.values.real_estate_agent = lo.calque_partner_contact_id;
					props.formik.setFieldValue('real_estate_agent', lo.calque_partner_contact_id)
					setRealEstateAgentValue(lo.calque_partner_contact_full_name)
					props.setAgentSelected(lo.calque_partner_contact_full_name);
					setIsOpen(false)
					props.setIsDisabledAgent(true)
				}
			})
		}
	}
	const debouncedSearch = useCallback(
		debounce(handleSearchValue, 200),
		[]
	);

	useEffect(() => {
		if (props.reset === true) {
			props.values.real_estate_agent_info.email = ''
		}
	},[props.reset])
	useEffect(() => {
		const checkIfClickedOutside = e => {
			if (ref.current && !ref.current.contains(e.target)) {
				setIsOpen(false)
			}
		}
		document.addEventListener("click", checkIfClickedOutside)
		return () => {
			document.removeEventListener("click", checkIfClickedOutside)
		}
	}, [isOpen])
	useEffect(() =>{
		if(props.values.is_real_estate_agent == "false" || props.values.is_real_estate_agent == "") {
		  setRealEstateAgentValue(null)
		  setIsExists(true)
		  props.values.real_estate_agent = '';
		  props.formik.setFieldValue('real_estate_agent', '')
		}
	  },[props.values.is_real_estate_agent])
	  useEffect(()=>{
        let res = realEstateAgent && realEstateAgent.filter(o=> o.calque_partner_contact_id === props.values.real_estate_agent)
        if(res.length !== 0) {
            props.values.real_estate_agent_info.first_name = res[0].first_name;
            props.values.real_estate_agent_info.last_name = res[0].last_name;
            props.values.real_estate_agent_info.email = res[0].email;
            props.values.real_estate_agent_info.phone_number = res[0].phone_number;
        }
    },[realEstateAgentValue])

	function StyledRadio(props) {
		const useStyles = makeStyles({
			root: {
				'&:hover': {
					backgroundColor: 'transparent',
				},
			}
		})
		const classes = useStyles();
		return (
			<Radio
				className={classes.root}
				disableripple="true"
				color="default"
				checkedIcon={<CheckCircleIcon className="checkedIcon" />}
				icon={<RadioButtonUncheckedIcon />}
				{...props}
			/>
		);
	}

	return (
		<div className="form-question">
			<div className="form-content" >
				<h4 className="form-content-heading m-0">
					Do you have a real estate agent?
				</h4>
				<div className="pt-3">
					<RadioGroup row name="is_real_estate_agent" style={{width: '150px'}} value={props.values.is_real_estate_agent} onChange={props.handleChange} onClick={resetAllInputField}>
						<div>
							<FormControlLabel value="true" control={<StyledRadio />} label="Yes" />
						</div>
						<div>
							<FormControlLabel value="false" control={<StyledRadio />} label="No" />
						</div>
					</RadioGroup>
				</div>
				<div className="check-box form-content-field">
					<div className="py-2">
						{props.values.is_real_estate_agent === 'true' ?
							<div>
								{props?.partner?.url_path &&
									<div>
										<div className='d-none d-md-block'>
										<FormControl variant="outlined" className="property-select w-50 px-3 py-2 pb-3">
											<Autocomplete
												disablePortal
												ref={ref}
												name="real_estate_agent"
												onChange={(event, newValue) => {
													props.handleChange(event);
													handleChangeValue(newValue);
												}}
												popupIcon={false}
												style={props?.partner?.url_path === "c2" ? { fontFamily:"FTPolar-Light"}:{ padding: '0px 20px'}}
												closeIcon={<CloseIcon onClick={handleCloseIcon} fontSize="small" />}
												open={isOpen}
												onChangeCapture={debouncedSearch}
												className="loan_officer_Search"
												loading={isLoading}
												noOptionsText={<div className="not_found" onClick={() => handleNotFound()} style={{backgroundColor: '#1169b0', color: '#fff', width: '100%', padding: '5px 10px'}}>+Add New</div>}
												options={realEstateAgent && realEstateAgent.map((agent) => agent.calque_partner_contact_full_name)}
												value={props?.agentSelected ? props.agentSelected:realEstateAgentValue}
												renderInput={(params) => (
													<TextField 
														{...params} 
														placeholder="Search Real Estate Agent" 
														margin="normal" 
														variant="outlined"
														style={{ height: "52px", marginTop: '8px' }}
														fullWidth 
														InputProps={{
															...params.InputProps,
															readOnly: props.isDisabledAgent, 
														}}
													/>
												)}
												renderOption={(options) =>{
													return(<div style={{
														backgroundColor: options === '+Add New'? "#1c79c3" : "",
														color: options === '+Add New'? "#fff" : "",
														width: "100%",
														padding: '5px 10px'
													}}>
														{options}
													</div>)
												}}
											/>
										</FormControl>
                                        </div>
										<div className='d-block d-md-none'>
										<FormControl variant="outlined" className="property-select w-100 pl-3 pb-3">
											<Autocomplete
												disablePortal
												ref={ref}
												name="real_estate_agent"
												onChange={(event, newValue) => {
													props.handleChange(event);
													handleChangeValue(newValue);
												}}
												popupIcon={false}
												style={props?.partner?.url_path === "c2" ? { fontFamily:"FTPolar-Light"}:{ padding: '0px 20px'}}
												closeIcon={<CloseIcon onClick={handleCloseIcon} fontSize="small" />}
												open={isOpen}
												onChangeCapture={debouncedSearch}
												className="loan_officer_Search"
												loading={isLoading}
												noOptionsText={<div className="not_found" onClick={() => handleNotFound()} style={{backgroundColor: '#1169b0', color: '#fff', width: '100%', padding: '5px 10px'}}>+Add New</div>}
												options={realEstateAgent && realEstateAgent.map((agent) => agent.calque_partner_contact_full_name)}
												value={props?.agentSelected ? props.agentSelected:realEstateAgentValue}
												renderInput={(params) => (
													<TextField 
														{...params} 
														placeholder="Search Real Estate Agent" 
														margin="normal" 
														variant="outlined"
														style={{ height: "52px", marginTop: '8px' }}
														fullWidth 
														InputProps={{
															...params.InputProps,
															readOnly: props.isDisabledAgent, 
														}}
													/>
												)}
												renderOption={(options) =>{
												return(<div style={{
													backgroundColor: options === '+Add New'? "#1c79c3" : "",
													color: options === '+Add New'? "#fff" : "",
													width: "100%",
													padding: '5px 10px'
												}}>
													{options}
												</div>)
											}}
											/>
										</FormControl>
										</div>
									</div>
								}
								{!isExists || props.isSelectedAgent ?
									<div className="form-content-field">
										<div className="py-2">
											<div className="w-res-50 py-2 d-sm-flex">
												<div className="col-12 col-sm-6 pl-sm-0 pr-sm-2 p-0">
													<div className="pb-2">
														<h6 className="m-0" style={props?.partner?.url_path === "c2" ? { fontFamily:"FTPolar-semibold"}:{}}>First Name<span className="red-color">*</span></h6>
													</div>
													<div>
														<TextField
															type="text"
															id="real_estate_agent_info.first_name"
															variant="outlined"
															name="real_estate_agent_info.first_name"
															className="form-TextField"
															onBlur={(e) => (handleFirstName(e))}
															onChange={props.handleChange}
															value={props.values.real_estate_agent_info.first_name}
														/>
													</div>
												</div>
												<div className="col-12 col-sm-6 pr-sm-0 pl-sm-2 p-0 pt-3 pt-sm-0">
													<div className="pb-2">
														<h6 className="m-0" style={props?.partner?.url_path === "c2" ? { fontFamily:"FTPolar-semibold"}:{}}>Last Name<span className="red-color">*</span></h6>
													</div>
													<div>
														<TextField
															type="text"
															id="last_name"
															variant="outlined"
															name="real_estate_agent_info.last_name"
															className="form-TextField"
															onChange={props.handleChange}
															onBlur={(e) => (handleLastName(e))}
															value={props.values.real_estate_agent_info.last_name}
														/>
													</div>
												</div>
											</div>
											<div className="w-res-50 py-2">
												<div className="pb-2">
													<h6 className="m-0" style={props?.partner?.url_path === "c2" ? { fontFamily:"FTPolar-semibold"}:{}}>Email Address</h6>
												</div>
												<div>
													<TextField
														type="email"
														id="email"
														variant="outlined"
														name="real_estate_agent_info.email"
														className="form-TextField"
														onChange={handleEmail, props.handleChange}
														value={props.values.real_estate_agent_info.email}
													/>
												</div>
											</div>
											<div className="w-res-50 py-2">
												<div className="pb-2">
													<h6 className="m-0" style={props?.partner?.url_path === "c2" ? { fontFamily:"FTPolar-semibold"}:{}}>Phone Number</h6>
												</div>
												<div>
													<div className="d-flex align-items-center" id="emailId">
														<div className="px-2 border rounded" style={{ height: '56px', padding: '17.5px 14px' }}>+1</div>
														<NumberFormat
															id="phoneNumber"
															className="phonenumber-field"
															format=" (###) ###-####"
															onChange={(e) => phoneNumberFormat(e)}
															onFocus={props.handleChange}
															value={props.values.real_estate_agent_info.phone_number}
															allowEmptyFormatting />
													</div>
												</div>
											</div>
										</div>
									</div>
								:""}
							</div>
							: ''}
						{props.validateDisplay7 === true ? props.errors.real_estate_agent ?
							<div className="error-msg" style={props?.partner?.url_path === "c2" ? { fontFamily:"FTPolar-Light"}:{}}>{props.errors.real_estate_agent}</div> : ''
							: ''}
					</div>
				</div>
			</div>
		</div>
	)
}
